import { AccentVariantEnum } from '@delmonicos/shared-design-system-react/src/components/accent-icon/accent-icon';
import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Tag } from '@delmonicos/shared-design-system-react/src/components/tag/tag';
import {
  Text,
  TextColor,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import { formatDate } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/formatters/format-date';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import i18n from '@app/core/locale/i18n';
import { mapEmspBoTransactionStatusToStyle } from '@app/feature/emsp-bo-charging-session/emsp-bo-charging-session-status.helper';

import { useEmspBoChargingSessionContext } from '../emsp-bo-charging-session.context';

export const EmspBoChargingSessionStatusListController =
  (): React.JSX.Element => {
    // CONTEXT ///////////////////////////////////////////////////////////////////

    const { t } = useTranslation();
    const chargingSession = useEmspBoChargingSessionContext();

    // RENDER ////////////////////////////////////////////////////////////////////

    const sortedStatus = [...(chargingSession.status ?? [])].reverse();

    return (
      <Card flex={1}>
        <Stack direction="column" gap={GapEnum.L}>
          <AccentTitle
            icon="clock-fast-forward"
            text={t(
              '$.emsp-bo-charging-session-details.session-status-history-card.title',
            )}
            as={HeadingEnum.H2}
            variant={AccentVariantEnum.Accent1}
          />
          {sortedStatus.length === 0 && <Text>-</Text>}
          {sortedStatus.map((entry, index) => {
            const { color } = mapEmspBoTransactionStatusToStyle(entry.type);
            return (
              <Stack
                key={index}
                alignItems="center"
                justifyContent="space-between">
                <Stack flex={1}>
                  <Text color={TextColor.Secondary}>
                    {formatDate(entry.createdAt, i18n)}
                  </Text>
                </Stack>
                <Stack flex={1} justifyContent="flex-end">
                  <Tag className={classNames(color)}>
                    {t(
                      `delmonicos-shared-sdk.enums-transaction-status.${entry.type}`,
                    )}
                  </Tag>
                </Stack>
              </Stack>
            );
          })}
        </Stack>
      </Card>
    );
  };
